// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Sv6x","location":"Header_location__1_r5G"};